import { SystemModules } from '../constants/system-modules'

export function isExternalRoute(url: string = typeof window !== 'undefined' ? window.location.pathname : ''): boolean {
  const path = (url.split('?')[0] || '').split('#')[0]
  const externalBase = `/${SystemModules.external.uri}`
  return path === externalBase || path.startsWith(`${externalBase}/`)
}
